import { Stack } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { appConfig } from '../configs/app-config';

const SOCIAL_LINKS = {
  facebook: 'https://facebook.com/jaiambeherbs',
  instagram: 'https://instagram.com/jaiambeherbs',
  whatsapp: `https://wa.me/${appConfig.appAuthorPhone.replace(/\D/g, '')}`,
};

const BRAND_COLORS = {
  facebook: '#1877F2',
  instagram: '#E4405F',
  whatsapp: '#25D366',
};

const baseIconSx = { cursor: 'pointer' };

const VARIANT_STYLES = {
  footer: {
    spacing: 1,
    facebookIcon: { ...baseIconSx, '&:hover': { color: BRAND_COLORS.facebook } },
    instagramIcon: { ...baseIconSx, '&:hover': { color: BRAND_COLORS.instagram } },
    whatsAppIcon: { ...baseIconSx, '&:hover': { color: BRAND_COLORS.whatsapp } },
  },
  inline: {
    spacing: 2,
    facebookIcon: { ...baseIconSx, '&:hover': { color: BRAND_COLORS.facebook } },
    instagramIcon: { ...baseIconSx, '&:hover': { color: BRAND_COLORS.instagram } },
    whatsAppIcon: { ...baseIconSx, '&:hover': { color: BRAND_COLORS.whatsapp } },
  },
};

export default function SocialIcons({ variant = 'inline', sx }) {
  const styles = VARIANT_STYLES[variant] ?? VARIANT_STYLES.inline;

  return (
    <Stack direction="row" spacing={styles.spacing} sx={sx}>
      {/* <FacebookIcon
        sx={styles.facebookIcon}
        onClick={() => window.open(SOCIAL_LINKS.facebook)}
      />
      <InstagramIcon
        sx={styles.instagramIcon}
        onClick={() => window.open(SOCIAL_LINKS.instagram)}
      /> */}
      <WhatsAppIcon
        sx={styles.whatsAppIcon}
        onClick={() => window.open(SOCIAL_LINKS.whatsapp)}
      />
    </Stack>
  );
}
